/**
 * The band of a vertical clip that a 16:9 frame shows with "Fill" (design c3), as a share of the
 * clip height: the clip width at 16:9 is `width * 9 / 16` tall. 1 for a clip that is not taller
 * than 16:9. Pure.
 */
export function cropBandShare(width: number, height: number): number {
  if (width <= 0 || height <= 0) {
    return 1;
  }
  return Math.min(1, (width * 9) / 16 / height);
}

/**
 * The `cropY` (0..1) that puts the middle of the band at `pointerShare` (0..1 of the clip height).
 * The band stays inside the clip. Pure.
 */
export function cropFromPointer(pointerShare: number, bandShare: number): number {
  if (bandShare >= 1) {
    return 0.5;
  }
  const top = pointerShare - bandShare / 2;
  return Math.min(1, Math.max(0, top / (1 - bandShare)));
}
